(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-home"] && !Shopify.designMode) return;
  try {
    
(() => {
 const setup = (root) => {
  root.querySelectorAll('[data-mp-hero]').forEach((hero) => {
   if (hero.dataset.ready) return;
   hero.dataset.ready = 'true';
   const slides = [...hero.querySelectorAll('[data-mp-hero-slide]')];
   if (!slides.length) return;
   const key = 'maple-puck-hero:' + hero.dataset.mpHero;
   let previous = '';
   try { previous = sessionStorage.getItem(key) || ''; } catch {}
   const choices = slides.map((slide,index) => index).filter(index => slides[index].dataset.productId !== previous);
   let active = choices.length ? choices[Math.floor(Math.random() * choices.length)] : 0;
   const show = (index, announce = false) => {
    active = (index + slides.length) % slides.length;
    slides.forEach((slide,i) => { slide.hidden = i !== active; });
    const slide = slides[active];
    const image = slide.querySelector('img');
    if (image) { image.loading = 'eager'; image.fetchPriority = 'high'; }
    hero.querySelector('[data-mp-hero-title]').textContent = slide.dataset.title;
    if (announce) hero.querySelector('[data-mp-hero-status]').textContent = slide.dataset.title;
    try { sessionStorage.setItem(key, slide.dataset.productId); } catch {}
   };
   show(active);
   if (slides.length > 1) {
    hero.querySelector('[data-mp-hero-controls]').hidden = false;
    hero.querySelector('[data-mp-hero-prev]').addEventListener('click', () => show(active - 1, true));
    hero.querySelector('[data-mp-hero-next]').addEventListener('click', () => show(active + 1, true));
   }
  });
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), {once:true});
 else setup(document);
 document.addEventListener('shopify:section:load', event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
